import { render, staticRenderFns } from "./TheContent.vue?vue&type=template&id=6b4e8400&scoped=true&"
import script from "./TheContent.vue?vue&type=script&lang=js&"
export * from "./TheContent.vue?vue&type=script&lang=js&"
import style0 from "./TheContent.vue?vue&type=style&index=0&id=6b4e8400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4e8400",
  null
  
)

export default component.exports